<template>
  <div class="content">
    <div
      class="md-layout"
      style="display: flex; align-items: center; padding-top: 100px"
    >
      <div
        class="md-layout-item md-medium-size-100 md-size-40"
        style="margin: 0 auto"
      >
        <div class="md-layout-item text-center" style="margin-bottom: 40px">
          <img src="../assets/img/buypower-logo.png" style="width: 50%" />
        </div>
        <form @submit.prevent="login()">
          <md-card>
            <md-card-header data-background-color="green">
              <h4 class="title">Admin Login</h4>
              <p class="category">Enter Login Details To Continue</p>
            </md-card-header>

            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item md-size-100">
                  <md-field>
                    <label>Phone Number / Email</label>
                    <md-input type="text" v-model="username"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-100">
                  <md-field>
                    <label>Password</label>
                    <md-input
                      type="password"
                      v-model="loginData.password"
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-100 text-center">
                  <md-button
                    class="md-raised md-primary"
                    data-background-color="orange"
                    type="submit"
                    >Login</md-button
                  >
                </div>
                <div class="md-layout-item md-size-100 text-right forgot-password">
                    <a href="/forget">Forgot Password?</a>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </form>

        <div class="text-center"><span>&copy; 2018 Buypower Inc.</span></div>
      </div>
    </div>

    <md-snackbar
      md-position="center"
      :md-duration="6000"
      :md-active.sync="snackBar.show"
      md-persistent
    >
      <span>{{ snackBar.message }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import http from '../utils/Http.util';
import Token from '../utils/Token.util';

export default {
  name: 'Login',
  data() {
    return {
      snackBar: {
        show: false,
        message: null,
      },
      loginData: {
        phone: null,
        password: null,
        email: null,
      },
      username: null,
    };
  },
  methods: {
    async login() {
      this.$store.commit('busyStatus', true);
      if (this.username.includes('@')) {
        this.loginData.email = this.username;
      } else {
        this.loginData.phone = this.username;
      }
      try {
        const response = await http.req(
          '/dashboard/signin',
          this.loginData,
          'post',
        );
        Token.saveToken(response.authToken);
        this.$store.commit('setAcl', response.acl);
        this.$store.commit('busyStatus', false);
        this.$router.push({ path: '/' });
      } catch (err) {
        this.snackBar = {
          show: true,
          message: err.response ? err.response.data.message : err.message,
        };
        this.$store.commit('busyStatus', false);
      }
    },
  },
};
</script>
